module.exports = __webpack_public_path__ + "img/funnel-fdisp-grezza-2022.624b7060.svg";